import { useAuth0 } from '@auth0/auth0-react';
import { Menu } from '@cimplico/components';
import { BellIcon, CogIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { useUserContext } from '../../providers/UserProvider';
import { ReactComponent as CimplicoLogo } from '../../assets/cimplico.svg';
import UserAvatar from '../avatar/UserAvatar';

function StartNavbar(): JSX.Element {
    const { firstName, lastName, avatarUrl, profileHexColour } = useUserContext();
    const { logout } = useAuth0();

    return (
        <nav className="flex items-center w-full bg-indigo-600 h-14 dark:bg-indigo-600/[0.6] px-8">
            <section className="flex gap-8 items-center">
                <CimplicoLogo className="h-12 w-12 cursor-pointer" />
            </section>
            <section className="ml-auto flex gap-8">
                <section className="flex items-center gap-4">
                    <QuestionMarkCircleIcon className="text-white h-5 w-5" />
                    <BellIcon className="text-white h-5 w-5" />
                    <CogIcon className="text-white h-5 w-5" />
                </section>

                <Menu>
                    <Menu.Button>
                        <div className="cursor-pointer">
                            <UserAvatar user={{ firstName, lastName, avatarUrl, profileHexColour }} />
                        </div>
                    </Menu.Button>
                    <Menu.Body position="left">
                        <div className="dark:text-white/[0.60] text-gray-700 cursor-pointer grid items-center py-2 text-sm">
                            <button
                                className={`hover:dark:bg-white/[0.09] hover:bg-gray-100 hover:text-gray-900 hover:dark:text-white/[0.87] text-left pl-4 pr-8 py-2`}
                                onClick={(): Promise<void> => logout({ logoutParams: { returnTo: window.location.origin } })}
                            >
                                Logout
                            </button>
                        </div>
                    </Menu.Body>
                </Menu>
            </section>
        </nav>
    );
}
export default StartNavbar;
